export enum EndpointsStatusesQueryKeys {
  Status = '/txn-info-receipt',
}

export enum StatusQueryKeys {
  Status = 'status',
}
